<template>
    <table class="mailTable" :style="styleObject" v-if="s_showByRow">
        <tr v-for="index in rowCount">
            <td class="column">{{tableData[index*2-2].key}}</td>
            <td>{{tableData[index*2-2].value}}</td>
            <td
                class="column"
            >{{tableData[index*2-1] !== undefined ? tableData[index*2-1].key : ''}}</td>
            <td>{{tableData[index*2-1] !== undefined ? tableData[index*2-1].value : ''}}</td>
        </tr>
    </table>
    <table class="mailTable" :style="styleObject" v-else>
        <tr v-for="index in rowCount">
            <td class="column">{{tableData[index-1].key}}</td>
            <td>{{tableData[index-1].value}}</td>
            <td
                class="column"
            >{{tableData[rowCount+index-1] !== undefined ? tableData[rowCount+index-1].key : ''}}</td>
            <td>{{tableData[rowCount+index-1] !== undefined ? tableData[rowCount+index-1].value : ''}}</td>
        </tr>
    </table>
</template>

<script>
export default {
    data() {
        return {
            styleObject: {},
            s_showByRow: true,
        };
    },
    props: ["tableData", "tableStyle", "showByRow"],
    computed: {
        rowCount: function () {
            return Math.ceil(this.tableData.length / 2);
        },
    },
    created() {
        this.styleObject = this.tableStyle;
        if (this.showByRow !== undefined) {
            this.s_showByRow = this.showByRow;
        }
    },
};
</script>

<style scoped>
.mailTable {
    margin-left: 10px;
    margin-bottom: 20px;
}
td {
    width: 25%;
    text-align: left;
    text-indent: 6px;
    line-height: 36px;
    height: 36px;
    color: #fff;
}
.column {
    /* background: #f8f8f8; */
    background: rgba(38, 77, 132, 0.6) !important;
    color: #56fbff;
}
table td,
table th {
    border-top: 1px solid #56fbff;
    border-left: 1px solid #56fbff;
}
table tr td:last-child,
table tr th:last-child {
    border-right: 1px solid #56fbff;
}
table tr:last-child td {
    border-bottom: 1px solid #56fbff;
}
table tr:first-child td:first-child,
table tr:first-child th:first-child {
    border-top-left-radius: 5px;
}
table tr:first-child td:last-child,
table tr:first-child th:last-child {
    border-top-right-radius: 5px;
}
table tr:last-child td:first-child {
    border-bottom-left-radius: 5px;
}
table tr:last-child td:last-child {
    border-bottom-right-radius: 5px;
}
</style>